import React from 'react';
import { number, func, string } from 'prop-types';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import styles from './styles';

export default function ButtonField({ field, children, onPress, index, style }) {
  const chosenStyle = index % 2 ? styles.evenRow : styles.oddRow;
  return (
    <div style={chosenStyle}>
      <UTLabel small bold>
        {field}
      </UTLabel>
      <UTButton onPress={onPress} textstyle style={{ ...styles.button, ...style }}>
        {children}
      </UTButton>
    </div>
  );
}

ButtonField.propTypes = {
  field: string.isRequired,
  children: string.isRequired,
  onPress: func.isRequired,
  index: number.isRequired
};
